"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnvConfigManager = void 0;
var DEV_CONFIG_1 = __importDefault(require("../../config/envConfig/DEV_CONFIG"));
var LOCAL_DEV_CONFIG_1 = __importDefault(require("../../config/envConfig/LOCAL_DEV_CONFIG"));
var LOCAL_PROD_CONFIG_1 = __importDefault(require("../../config/envConfig/LOCAL_PROD_CONFIG"));
var PROD_CONFIG_1 = __importDefault(require("../../config/envConfig/PROD_CONFIG"));
var QA_CONFIG_1 = __importDefault(require("../../config/envConfig/QA_CONFIG"));
var SIT_CONFIG_1 = __importDefault(require("../../config/envConfig/SIT_CONFIG"));
var HOTFIX_CONFIG_1 = __importDefault(require("../../config/envConfig/HOTFIX_CONFIG"));
var mfeSettings_1 = require("../mfe/mfeSettings");
var EvoConfigHelper_1 = require("../../config/envConfig/shared/EvoConfigHelper");
var EnvConfigManager = /** @class */ (function () {
    function EnvConfigManager() {
    }
    Object.defineProperty(EnvConfigManager, "config", {
        get: function () {
            var environment = this.ALL_ENV_NAME_TYPES.PRODUCTION; // DEFAULT for PROD ENVS
            if (this.NODE_ENV != "test" &&
                !!typeof window &&
                typeof window !== "undefined") {
                environment =
                    {
                        localhost: "local_".concat(this.NODE_ENV),
                        "dev.unipol.it": this.ALL_ENV_NAME_TYPES.DEVELOPMENT,
                        "sit.unipol.it": this.ALL_ENV_NAME_TYPES.INTEGRATION,
                        "qa.unipol.it": this.ALL_ENV_NAME_TYPES.QUALITY,
                        "fix.unipolsai.it": this.ALL_ENV_NAME_TYPES.HOTFIX,
                        "fix.unipol.it": this.ALL_ENV_NAME_TYPES.HOTFIX,
                        "unipolsai.it": this.ALL_ENV_NAME_TYPES.PRODUCTION,
                        "unipol.it": this.ALL_ENV_NAME_TYPES.PRODUCTION,
                        "www.unipolsai.it": this.ALL_ENV_NAME_TYPES.PRODUCTION,
                        "www.unipol.it": this.ALL_ENV_NAME_TYPES.PRODUCTION,
                        "authoring-inte.unipolsai.it": this.ALL_ENV_NAME_TYPES.INTEGRATION,
                        "authoring-inte.unipol.it": this.ALL_ENV_NAME_TYPES.INTEGRATION,
                        "authoring-svil.unipolsai.it": this.ALL_ENV_NAME_TYPES.DEVELOPMENT,
                        "authoring-svil.unipol.it": this.ALL_ENV_NAME_TYPES.DEVELOPMENT,
                        "authoring-coll.unipolsai.it": this.ALL_ENV_NAME_TYPES.QUALITY,
                        "authoring-coll.unipol.it": this.ALL_ENV_NAME_TYPES.QUALITY,
                        "authoring.unipolsai.it": this.ALL_ENV_NAME_TYPES.PRODUCTION,
                        "authoring.unipol.it": this.ALL_ENV_NAME_TYPES.PRODUCTION,
                        "svil.unipolsai.it": this.ALL_ENV_NAME_TYPES.DEVELOPMENT,
                        "svil.unipol.it": this.ALL_ENV_NAME_TYPES.DEVELOPMENT,
                        "inte.unipolsai.it": this.ALL_ENV_NAME_TYPES.INTEGRATION,
                        "inte.unipol.it": this.ALL_ENV_NAME_TYPES.INTEGRATION,
                        "coll.unipolsai.it": this.ALL_ENV_NAME_TYPES.QUALITY,
                        "coll.unipol.it": this.ALL_ENV_NAME_TYPES.QUALITY,
                        "evo-dev.unipolsai.it": this.ALL_ENV_NAME_TYPES.DEVELOPMENT,
                        "evo-dev.unipol.it": this.ALL_ENV_NAME_TYPES.DEVELOPMENT,
                        "evo-sit.unipolsai.it": this.ALL_ENV_NAME_TYPES.INTEGRATION,
                        "evo-sit.unipol.it": this.ALL_ENV_NAME_TYPES.INTEGRATION, // rebranding midnight 2025
                    }[window.location.hostname] || environment;
            }
            else if (this.isEnvConfigAvailableBy(this.DEPLOY_ENV_NAME)) {
                environment = this.DEPLOY_ENV_NAME;
            }
            else if (this.DEPLOY_ENV_NAME === "local") {
                environment = "local_".concat(this.NODE_ENV);
            }
            else if (this.npm_package_version &&
                this.npm_package_version.includes("-SNAPSHOT")) {
                environment = this.ALL_ENV_NAME_TYPES.DEVELOPMENT;
            }
            return this.ALL_ENV_CONFIG[environment];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EnvConfigManager, "ALL_ENV_CONFIG", {
        get: function () {
            var _a;
            return _a = {},
                _a[this.ALL_ENV_NAME_TYPES.LOCAL_DEVELOPMENT] = LOCAL_DEV_CONFIG_1.default,
                _a[this.ALL_ENV_NAME_TYPES.LOCAL_PRODUCTION] = LOCAL_PROD_CONFIG_1.default,
                _a[this.ALL_ENV_NAME_TYPES.LOCAL_TEST] = LOCAL_DEV_CONFIG_1.default,
                _a[this.ALL_ENV_NAME_TYPES.DEVELOPMENT] = DEV_CONFIG_1.default,
                _a[this.ALL_ENV_NAME_TYPES.INTEGRATION] = SIT_CONFIG_1.default,
                _a[this.ALL_ENV_NAME_TYPES.QUALITY] = QA_CONFIG_1.default,
                _a[this.ALL_ENV_NAME_TYPES.HOTFIX] = HOTFIX_CONFIG_1.default,
                _a[this.ALL_ENV_NAME_TYPES.PRODUCTION] = PROD_CONFIG_1.default,
                _a;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EnvConfigManager, "ENV_NAME", {
        get: function () {
            return this.config.ENV_NAME;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EnvConfigManager, "CMS_PROXY_ENDPOINT", {
        get: function () {
            return this.config.CMS_PROXY_ENDPOINT;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EnvConfigManager, "CMS_PROXY_NO_APIC_ENDPOINT", {
        get: function () {
            return this.config.CMS_PROXY_NO_APIC_ENDPOINT;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EnvConfigManager, "HOST_ENDPOINT", {
        get: function () {
            return this.config.HOST_ENDPOINT;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EnvConfigManager, "ENV_BRANCH_TYPE", {
        get: function () {
            return (0, EvoConfigHelper_1.__isEvoEnvBy)()
                ? this.ALL_ENV_BRANCH_TYPES.EVOLUTION
                : this.ALL_ENV_BRANCH_TYPES.MAINTENANCE;
        },
        enumerable: false,
        configurable: true
    });
    EnvConfigManager.getRemoteEndpointBy = function (mfeType) {
        var remoteEndpoint = "";
        var _a = mfeSettings_1.MFE_GENERAL_SETTINGS[mfeType], localProdPort = _a.localProdPort, basePath = _a.basePath;
        switch (this.ENV_NAME) {
            case this.ALL_ENV_NAME_TYPES.LOCAL_DEVELOPMENT:
                remoteEndpoint = "http://localhost";
                break;
            case this.ALL_ENV_NAME_TYPES.LOCAL_PRODUCTION:
                remoteEndpoint = "https://localhost:".concat(localProdPort, "/").concat(basePath);
                break;
            default:
                remoteEndpoint = "".concat(this.HOST_ENDPOINT, "/").concat(basePath);
                break;
        }
        return remoteEndpoint;
    };
    Object.defineProperty(EnvConfigManager, "REVALIDATE_TOKEN", {
        get: function () {
            return this.config.REVALIDATE_TOKEN;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EnvConfigManager, "REMOTES_ENTRIES", {
        get: function () {
            var _this = this;
            var remotesEntries = {};
            switch (this.ENV_NAME) {
                case this.ALL_ENV_NAME_TYPES.LOCAL_DEVELOPMENT:
                    remotesEntries = Object.values(mfeSettings_1.MFE_SETTINGS).reduce(function (acc, mfeSettings) {
                        var _a;
                        var remoteEndpoint = _this.getRemoteEndpointBy(mfeSettings.type);
                        var clientPort;
                        var serverPort;
                        if (mfeSettings.devClientPort === mfeSettings.devServerPort) {
                            clientPort = "".concat(mfeSettings.devClientPort, "/client");
                            serverPort = "".concat(mfeSettings.devServerPort, "/server");
                        }
                        else {
                            clientPort = mfeSettings.devClientPort;
                            serverPort = mfeSettings.devServerPort;
                        }
                        return __assign(__assign({}, acc), (_a = {}, _a[mfeSettings.__mfeName__] = {
                            client: "".concat(remoteEndpoint, ":").concat(clientPort, "/remoteEntry.js"),
                            server: "".concat(remoteEndpoint, ":").concat(serverPort, "/remoteEntry.js"),
                        }, _a));
                    }, {});
                    break;
                case this.ALL_ENV_NAME_TYPES.LOCAL_PRODUCTION:
                    remotesEntries = Object.values(mfeSettings_1.MFE_SETTINGS).reduce(function (acc, mfeSettings) {
                        var _a;
                        var remoteEndpoint = _this.getRemoteEndpointBy(mfeSettings.type) || "";
                        return __assign(__assign({}, acc), (_a = {}, _a[mfeSettings.__mfeName__] = {
                            client: "".concat(remoteEndpoint, "/").concat(mfeSettings.__mfeName__, "/client/remoteEntry.js"),
                            server: "".concat(remoteEndpoint, "/").concat(mfeSettings.__mfeName__, "/server/remoteEntry.js"),
                        }, _a));
                    }, {});
                    break;
                default:
                    remotesEntries = Object.values(mfeSettings_1.MFE_SETTINGS).reduce(function (acc, mfeSettings) {
                        var _a;
                        var remoteEndpoint = _this.getRemoteEndpointBy(mfeSettings.type);
                        return __assign(__assign({}, acc), (_a = {}, _a[mfeSettings.__mfeName__] = {
                            client: "".concat(remoteEndpoint, "/").concat(mfeSettings.__mfeName__, "/client/remoteEntry.js"),
                            server: "".concat(remoteEndpoint, "/").concat(mfeSettings.__mfeName__, "/server/remoteEntry.js"),
                        }, _a));
                    }, {});
                    break;
            }
            return remotesEntries;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EnvConfigManager, "PRODOTTO_UNICO_ACTIVE", {
        get: function () {
            return this.config.PRODOTTO_UNICO_ACTIVE;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EnvConfigManager, "NETWORK_CONFIG", {
        get: function () {
            return this.config.NETWORK_CONFIG;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EnvConfigManager, "DEPLOY_ENV_NAME", {
        get: function () {
            throw new Error("method DEPLOY_ENV_NAME not defined");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EnvConfigManager, "npm_package_version", {
        get: function () {
            throw new Error("method npm_package_version not defined");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EnvConfigManager, "NODE_ENV", {
        get: function () {
            throw new Error("method NODE_ENV not defined");
        },
        enumerable: false,
        configurable: true
    });
    EnvConfigManager.isEnvConfigAvailableBy = function (configKey) {
        return (configKey &&
            Object.keys(this.ALL_ENV_CONFIG).findIndex(function (key) { return key === configKey; }) >
                -1);
    };
    EnvConfigManager.ALL_ENV_NAME_TYPES = {
        // local envs
        LOCAL_DEVELOPMENT: "local_development",
        LOCAL_PRODUCTION: "local_production",
        LOCAL_TEST: "local_test",
        // NO-PROD envs
        DEVELOPMENT: "development",
        INTEGRATION: "integration",
        HOTFIX: "hotfix",
        QUALITY: "quality",
        // PROD envs
        PRODUCTION: "production",
    };
    EnvConfigManager.ALL_ENV_BRANCH_TYPES = {
        MAINTENANCE: "maintenance",
        EVOLUTION: "evolution",
    };
    return EnvConfigManager;
}());
exports.EnvConfigManager = EnvConfigManager;
